"use client";

import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useTranslation } from "react-i18next";
import { getLocaleFromPath } from "../lib/i18n/utils";
import Icon from "./Icon";
import BookingCTA from "./BookingCTA";

export default function Footer() {
  const { t } = useTranslation();
  const pathname = usePathname();
  const locale = getLocaleFromPath(pathname);
  return (
    <footer className="bg-ui-card">
      <div className="w-full px-2.5 py-10">
        <div className="mx-auto w-full max-w-7xl bg-ui-page px-10 py-8">
          <div className="flex flex-col items-center gap-8 md:flex-row md:items-center md:justify-between">
            <div className="flex items-center gap-8">
              <Image
                src="/logo-full.png"
                alt={t("To Spiti Tis Sofias")}
                width={140}
                height={90}
                suppressHydrationWarning
              />
              <div className="hidden h-24 w-px bg-ui-card md:block" />
            </div>

            <div className="flex flex-col items-center gap-2 lg:flex-row lg:gap-6">
              <Link
                href="tel:+302144081916"
                className="group flex items-center gap-2 text-ui-card transition hover:text-brand-accent"
              >
                <Icon name="phone" size="md" className="text-ui-card transition group-hover:text-brand-accent" />
                {t("(+30) 214 408 1916")}
              </Link>

              <Link
                href="mailto:reservations@tospititissofias.gr"
                className="group flex items-center gap-2 text-ui-card transition hover:text-brand-accent"
              >
                <Icon name="envelope" size="md" className="text-ui-card transition group-hover:text-brand-accent" />
                reservations@tospititissofias.gr
              </Link>
            </div>

            <div className="flex items-center">
              <BookingCTA className="text-ui-card" />
            </div>
          </div>
        </div>

        <div className="mt-8 text-center text-ui-muted">
          <div className="mb-8 max-w-4xl mx-auto">
            <h3 className="text-white font-normal mb-4 text-sm">{t("Navigation")}</h3>
            <nav className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              <Link href={locale === "el" ? "/" : `/${locale}`} className="text-white/70 hover:text-white transition-colors text-sm">
                {t("The guesthouse")}
              </Link>
              <span className="text-white/30">•</span>
              <Link href={locale === "el" ? "/where" : `/${locale}/where`} className="text-white/70 hover:text-white transition-colors text-sm">
                {t("Where we are")}
              </Link>
              <span className="text-white/30">•</span>
              <Link href={locale === "el" ? "/rooms" : `/${locale}/rooms`} className="text-white/70 hover:text-white transition-colors text-sm">
                {t("Rooms")}
              </Link>
              <span className="text-white/30">•</span>
              <Link href={locale === "el" ? "/area" : `/${locale}/area`} className="text-white/70 hover:text-white transition-colors text-sm">
                {t("The area")}
              </Link>
              <span className="text-white/30">•</span>
              <Link href={locale === "el" ? "/contact" : `/${locale}/contact`} className="text-white/70 hover:text-white transition-colors text-sm">
                {t("Contact")}
              </Link>
            </nav>
          </div>
          <div className="text-sm" suppressHydrationWarning>{t("ΜΗΤΕ 1322915")}</div>
          <div className="text-sm" suppressHydrationWarning>
            {t("Copyright © 2009 – {{year}} All Rights Reserved", { year: new Date().getFullYear() })}
          </div>
        </div>
      </div>
    </footer>
  );
}
